import { IExtensionState } from "./extension.types";

export const initialState: IExtensionState = {
  isLoading: true,
  isExtension: false,
  asin: null,
  mode: "dock_right",
  title: null,
  amazonEmbededView: "short",
};
